import { Box } from '@chakra-ui/react'
import { PrimitiveAtom, useAtom } from 'jotai'

import { currentEnv } from '@/env/vars'
import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { getVisualAgentInfo } from '@/store/gigiChat/Visuals'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

import UploadFilesToAgent from '../uploadFilesToAgent/UploadFilesToAgent'

const UploadArea = ({ handleMessage }: { handleMessage: (question: string, fileURLManager?: Array<string>) => void }) => {
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)
    const agentInfo = getVisualAgentInfo(chatSettings?.processingModeAgent?.name)

    if (
        (currentEnv.features.isEnabled('useAgent') &&
            agentInfo &&
            agentInfo.supportsAttachments &&
            chatSettings?.processingStrategy === 'QA') ||
        (currentEnv.features.isEnabled('imageUnderstanding') && chatSettings?.processingStrategy === 'Writing')
    ) {
        return (
            <Box position="absolute" top="28%" left="20px" zIndex={2}>
                <UploadFilesToAgent handleMessage={handleMessage} />
            </Box>
        )
    }

    return null
}

export default UploadArea
